var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 0.287598C5.82969 0.287598 0 6.11729 0 13.2876C0 20.4579 5.82969 26.2876 13 26.2876C20.1703 26.2876 26 20.4579 26 13.2876C26 6.11729 20.1703 0.287598 13 0.287598Z",
    fill: "#F34235"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5859 14.2271C18.5859 17.3095 16.0773 19.813 13 19.813C9.91758 19.813 7.41406 17.3044 7.41406 14.2271C7.41406 12.3278 8.36367 10.5759 9.9582 9.54502C10.334 9.30127 10.8367 9.40791 11.0805 9.78369C11.3242 10.1595 11.2176 10.6622 10.8418 10.906C9.70938 11.6372 9.03906 12.8813 9.03906 14.2271C9.03906 16.4106 10.8164 18.188 13 18.188C15.1836 18.188 16.9609 16.4106 16.9609 14.2271C16.9609 12.8813 16.2855 11.6372 15.1582 10.906C14.7824 10.6622 14.6758 10.1595 14.9195 9.78369C15.1633 9.40791 15.666 9.30127 16.0418 9.54502C17.6363 10.5759 18.5859 12.3278 18.5859 14.2271ZM12.1875 11.3274V7.57471C12.1875 7.12783 12.5531 6.76221 13 6.76221C13.4469 6.76221 13.8125 7.12783 13.8125 7.57471V11.3274C13.8125 11.7743 13.4469 12.1399 13 12.1399C12.5531 12.1399 12.1875 11.7743 12.1875 11.3274Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.fd22a0842f068397cc55228fb3cb016e.svg";
export { ForwardRef as ReactComponent };